import { SettingsSideBarItemMenu } from 'modules/settings/components/side-menu-list';
import { useDeviceTypes } from 'core/contexts/device-types/hooks/use-device-types.hook';
import { hasDeviceSettings, sortMenuOptionsByTitle } from './settings-devices-menu.business';
import { mapDeviceTypeToSettingsMenuOption } from './settings-devices-menu.mapper';

interface UseGetSettingsDevicesMenu {
    settingsDevicesMenuOptions: SettingsSideBarItemMenu[];
    isLoading: boolean;
}

export const useGetSettingsDevicesMenu = (): UseGetSettingsDevicesMenu => {
    const { deviceTypes, isLoading = false } = useDeviceTypes();

    const settingsDevicesMenuOptions = sortMenuOptionsByTitle(
        deviceTypes.filter(hasDeviceSettings).map(mapDeviceTypeToSettingsMenuOption)
    );

    return { settingsDevicesMenuOptions, isLoading };
};
